
  var _styles = {
  "calendar-modal-body-container": {
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0
  },
  "calendar-modal-header-container": {
    "display": "flex",
    "flexDirection": "row",
    "padding": "0.42667rem",
    "justifyContent": "space-between"
  },
  "calendar-modal-header--title": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.48rem",
    "color": "rgb(32,32,32)",
    "letterSpacing": 0,
    "lineHeight": "0.64rem"
  },
  "calendar-modal-header--close-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  },
  "calendar-main-container": {
    "maxHeight": "10.26667rem"
  },
  "calendar-days-body-container": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "paddingLeft": "0.08rem"
  },
  "calendar-days-header-container": {
    "display": "flex",
    "flexDirection": "row",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "lineHeight": "0.37333rem",
    "borderBottomWidth": "0.01333rem",
    "borderBottomStyle": "solid",
    "borderBottomColor": "rgb(229,229,229)",
    "paddingTop": "0.37333rem",
    "paddingRight": 0,
    "paddingBottom": "0.37333rem",
    "paddingLeft": 0
  },
  "calendedar-month-header": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.48rem",
    "color": "rgb(32,32,32)",
    "lineHeight": "0.64rem",
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": "0.32rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.42667rem",
    "fontWeight": "bold"
  },
  "calendar-days-header-hightlight": {
    "color": "rgb(226,2,2)"
  },
  "calendar-days-header-item": {
    "width": "1.36rem",
    "textAlign": "center"
  },
  "calendar-days-single-item": {
    "width": "100%",
    "height": "1.65333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "calendar-days-single-main--disabled": {
    "color": "rgb(204,204,204)"
  },
  "calendar-days-single-extra": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "letterSpacing": 0,
    "textAlign": "center",
    "position": "absolute",
    "width": "100%",
    "whiteSpace": "nowrap",
    "top": "0.13333rem",
    "left": 0
  },
  "calendar-days-single-extra--red": {
    "color": "rgb(224,32,32)"
  },
  "calendar-days-single-extra--blue": {
    "color": "rgb(0,66,155)"
  },
  "calendar-days-single-extra--disabled": {
    "color": "rgb(204,204,204)"
  },
  "calendar-days-single-main": {
    "fontSize": "0.45333rem",
    "color": "rgb(32,32,32)",
    "letterSpacing": 0,
    "textAlign": "center"
  },
  "calendar-days-single-item-container": {
    "width": "1.36rem",
    "height": "1.65333rem",
    "marginRight": "0.05333rem",
    "marginBottom": "0.05333rem",
    "flexShrink": 0,
    "flexGrow": 0
  },
  "calendar-footer-confirm-button": {
    "marginTop": "0.32rem",
    "marginRight": "0.41333rem",
    "marginBottom": "0.58667rem",
    "marginLeft": "0.41333rem",
    "paddingTop": "0.28rem",
    "paddingRight": 0,
    "paddingBottom": "0.28rem",
    "paddingLeft": 0,
    "background": "#00429b",
    "borderRadius": "0.58667rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "center",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center"
  },
  "calendar-footer-confirm-button--disable": {
    "background": "#ccc"
  },
  "calendar-days-single-tooltip": {
    "position": "absolute",
    "backgroundColor": "rgb(32,32,32)",
    "opacity": 0.8,
    "borderRadius": "0.21333rem",
    "height": "1.50667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "justify",
    "padding": "0.26667rem",
    "zIndex": 99,
    "display": "flex",
    "flexDirection": "row"
  },
  "calendar-days-single-tooltip-invalid": {
    "width": "2.84rem",
    "height": "0.93333rem",
    "textAlign": "center",
    "bottom": "-1.04rem"
  },
  "calendar-days-single-tooltip--left": {
    "left": 0
  },
  "calendar-days-single-tooltip--right": {
    "right": 0
  },
  "calendar-days-single-tooltip-dawn": {
    "width": "7.01333rem",
    "height": "1.38667rem",
    "bottom": "-1.49333rem",
    "lineHeight": "0.36rem"
  },
  "calendar-days-single-tooltip--triangle": {
    "position": "absolute",
    "top": "-0.09333rem",
    "left": "50%",
    "transform": "translateX(-0.13333rem)",
    "zIndex": 1,
    "height": "0.09333rem",
    "width": "0.26667rem"
  },
  "calendar-days-single-tooltip--triangle-img": {
    "height": "0.09333rem",
    "width": "0.26667rem"
  },
  "calendar-days-single-tooltip--triangle-left": {
    "left": "0.74667rem"
  },
  "calendar-days-single-tooltip--triangle-right": {
    "right": "0.48rem",
    "left": "auto"
  },
  "calendar-days-single-tooltip--container": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "color": "rgb(255,255,255)"
  },
  "calendar-days-single-tooltip--closebtn": {
    "width": "0.32rem",
    "height": "0.32rem",
    "marginLeft": "0.32rem",
    "flexGrow": 0,
    "flexShrink": 0
  },
  "calendar-days-single-tooltip--yellow": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.32rem",
    "color": "rgb(255,207,0)",
    "letterSpacing": 0,
    "textAlign": "justify",
    "lineHeight": "0.44rem"
  },
  "calendar-footer-container": {
    "borderTopWidth": "0.01333rem",
    "borderTopStyle": "solid",
    "borderTopColor": "rgb(229,229,229)"
  },
  "calendar-footer-livedays-tip-icon": {
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "calendar-footer-livedays-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.64rem",
    "paddingBottom": 0,
    "paddingLeft": "0.69333rem"
  },
  "calendar-footer-livedays-empty": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.42667rem",
    "color": "rgb(204,204,204)"
  },
  "calendar-footer-livedays-time": {
    "display": "flex",
    "flexDirection": "row",
    "fontSize": "0.42667rem",
    "color": "rgb(32,32,32)",
    "lineHeight": "0.42667rem",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "calendar-footer-confirm-button--num": {
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "marginLeft": "0.10667rem",
    "marginRight": "0.10667rem"
  },
  "calendar-footer-livedays-time-tip": {
    "marginLeft": "0.13333rem"
  },
  "calendar-footer-livedays-tip": {
    "height": "0.34667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(119,119,119)",
    "lineHeight": "0.32rem",
    "marginBottom": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "calendar-footer-livedays-tip--enforce": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(32,32,32)",
    "marginTop": "-0.04rem"
  },
  "calendar-footer-livedays-split": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "calendar-footer-livedays-split-symbol": {
    "width": "0.26667rem",
    "height": "0.05333rem",
    "marginTop": "0.42667rem"
  },
  "calendar-days-single-item--selected": {
    "color": "rgb(255,255,255)",
    "background": "#00429b",
    "borderRadius": "0.16rem",
    "zIndex": 1
  },
  "calendar-days-single-item--selected-start": {
    "zIndex": 4
  },
  "calendar-days-single-main--selected": {
    "color": "rgb(255,255,255)"
  },
  "calendar-days-single-item--selected-middle": {
    "background": "#e8ecf4",
    "marginLeft": "-0.10667rem",
    "paddingLeft": "0.10667rem",
    "width": "1.46667rem",
    "zIndex": 0
  },
  "calendar-days-single-item--selected-middle-right": {
    "borderTopRightRadius": "0.21333rem",
    "borderBottomRightRadius": "0.21333rem"
  },
  "calendar-days-single-item--selected-middle-left": {
    "borderTopLeftRadius": "0.21333rem",
    "borderBottomLeftRadius": "0.21333rem",
    "marginLeft": 0,
    "paddingLeft": 0,
    "width": "1.36rem"
  },
  "calendar-days-single-item--selected-middle-startside": {
    "marginLeft": "-0.10667rem",
    "paddingLeft": "0.10667rem",
    "width": "1.46667rem"
  },
  "calendar-days-single-item--selected-middle-endside": {
    "marginRight": "-0.05333rem",
    "paddingRight": "0.10667rem",
    "width": "1.57333rem"
  },
  "calendar-days-single-item--selected-middle-left-endside": {
    "width": "1.46667rem"
  },
  "calendar-footer-livedays-item": {
    "height": "0.96rem",
    "maxHeight": "0.96rem"
  },
  "calendar-main-tip-container": {
    "paddingTop": "0.4rem",
    "paddingBottom": "0.66667rem",
    "textAlign": "center",
    "fontWeight": "400",
    "opacity": 0.99,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(119,119,119)",
    "letterSpacing": 0
  },
  "calendar-days-single-extra--small": {
    "fontSize": "0.24rem",
    "transformOrigin": "center"
  },
  "calendar-modal-loading-container": {
    "height": "12.06667rem"
  }
};



  module.exports = _styles;
  